import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { Product } from 'teacher-ui-client/utils/products'
import type { PhosphorIconName } from 'phosphor-icons'

export interface QuickAction {
  id: string
  labelKey: string
  icon: PhosphorIconName
  route: string
  models: string[]
}

const ICON_CREATE: PhosphorIconName = 'phosphor-plus'
const ICON_VIEW: PhosphorIconName = 'phosphor-eye'
const ICON_MANAGE: PhosphorIconName = 'phosphor-sun'

export const QUICK_ACTIONS_BY_SUBSCRIPTION_TYPE: Record<SubscriptionType, QuickAction[]> = {
  [SubscriptionType.Reading]: [
    {
      id: 'create-rex-assignment',
      labelKey: 'teacherHome.widgets.quickActions.actions.createRexAssignment',
      icon: ICON_CREATE,
      route: 'assignments.product.create',
      models: [Product.REX],
    },
    {
      id: 'create-re-assignment',
      labelKey: 'teacherHome.widgets.quickActions.actions.createReAssignment',
      icon: ICON_CREATE,
      route: 'assignments.product.create',
      models: [Product.RE],
    },
    {
      id: 'create-fp-assignment',
      labelKey: 'teacherHome.widgets.quickActions.actions.createFpAssignment',
      icon: ICON_CREATE,
      route: 'assignments.product.create',
      models: [Product.FP],
    },
    {
      id: 'view-current-rex-assignments',
      labelKey: 'teacherHome.widgets.quickActions.actions.viewCurrentRexAssignments',
      icon: ICON_VIEW,
      route: 'assignments.product.manage.current',
      models: [Product.REX],
    },
    {
      id: 'view-current-re-assignments',
      labelKey: 'teacherHome.widgets.quickActions.actions.viewCurrentReAssignments',
      icon: ICON_VIEW,
      route: 'assignments.product.manage.current',
      models: [Product.RE],
    },
    {
      id: 'manage-progress',
      labelKey: 'teacherHome.widgets.quickActions.actions.manageProgress',
      icon: ICON_MANAGE,
      route: 'manage.progress',
      models: [],
    },
  ],
  [SubscriptionType.Writing]: [
    {
      id: 'create-writing-assignment',
      labelKey: 'teacherHome.widgets.quickActions.actions.createWritingAssignment',
      icon: ICON_CREATE,
      route: 'assignments.product.create',
      models: [Product.WL],
    },
    {
      id: 'view-current-writing-assignments',
      labelKey: 'teacherHome.widgets.quickActions.actions.viewCurrentWritingAssignments',
      icon: ICON_VIEW,
      route: 'assignments.product.manage.current',
      models: [Product.WL],
    },
    {
      id: 'manage-progress',
      labelKey: 'teacherHome.widgets.quickActions.actions.manageProgress',
      icon: ICON_MANAGE,
      route: 'manage.progress',
      models: [],
    },
    {
      id: 'manage-students',
      labelKey: 'teacherHome.widgets.quickActions.actions.manageStudents',
      icon: ICON_MANAGE,
      route: 'manage.students',
      models: [],
    },
  ],
  [SubscriptionType.Maths]: [
    {
      id: 'create-maths-assignment',
      labelKey: 'teacherHome.widgets.quickActions.actions.createMathsAssignment',
      icon: ICON_CREATE,
      route: 'assignments.product.create',
      models: [Product.MS],
    },
    {
      id: 'view-current-maths-assignments',
      labelKey: 'teacherHome.widgets.quickActions.actions.viewCurrentMathsAssignments',
      icon: ICON_VIEW,
      route: 'assignments.product.manage.current',
      models: [Product.MS],
    },
    {
      id: 'manage-progress',
      labelKey: 'teacherHome.widgets.quickActions.actions.manageProgress',
      icon: ICON_MANAGE,
      route: 'manage.progress',
      models: [],
    },
    {
      id: 'manage-certificates',
      labelKey: 'teacherHome.widgets.quickActions.actions.manageCertificates',
      icon: ICON_MANAGE,
      route: 'manage.certificates',
      models: [],
    },
    {
      id: 'manage-students',
      labelKey: 'teacherHome.widgets.quickActions.actions.manageStudents',
      icon: ICON_MANAGE,
      route: 'manage.students',
      models: [],
    },
  ],
}
